import { render, staticRenderFns } from "./TasksListing.vue?vue&type=template&id=50be151c&scoped=true"
import script from "./TasksListing.vue?vue&type=script&lang=js"
export * from "./TasksListing.vue?vue&type=script&lang=js"
import style0 from "./TasksListing.vue?vue&type=style&index=0&id=50be151c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be151c",
  null
  
)

export default component.exports